import React, { useState, useRef, useEffect, useContext, useMemo } from "react";
import {
  CellMeasurer,
  CellMeasurerCache,
  createMasonryCellPositioner,
  Masonry,
  WindowScroller,
  AutoSizer,
} from "react-virtualized";
import { Popover, Tooltip } from "antd";
import { SimpleImg } from "react-simple-img";
import { AuditMarkingContext } from "../../../context";
import * as actiontypes from "../../../reducer/action";
// import Zmage from 'react-zmage';
import { Modal } from "antd";
import "./WaterFall.less";

const cache = new CellMeasurerCache({
  defaultHeight: 250,
  defaultWidth: 300,
  fixedWidth: true,
});
const cellPositioner = createMasonryCellPositioner({
  cellMeasurerCache: cache,
  columnCount: 5,
  columnWidth: 300,
  spacer: 10,
});

// const imgSuffix = (w) => {
// 	return `?x-oss-process=image/auto-orient,1/resize,m_lfit,w_${Math.floor(
// 		w
// 	)}/quality,q_100/format,webp`;
// };

const renderTagsList = (tagsList, type) => {
  if (type === 1) {
    if (tagsList && tagsList?.length > 0) {
      return tagsList.map((v) => {
        if (v.type === 1) {
          return <li key={v.id}>{v.word + "【" + v.entity + "】"}</li>;
        } else if (v.type === 2) {
          return <li key={v.id}>{v.word + "【自定义】"}</li>;
        } else {
          return <li key={v.id}>{v.word + "【" + v.style + "】"}</li>;
        }
      });
    } else {
      return <li>无标签</li>;
    }
  } else {
    return (
      (tagsList && tagsList?.length > 0 && tagsList.map((v) => v.word + "/")) ||
      "无标签"
    );
  }
};

const cellRenderer = ({
  index,
  parent,
  style,
  list,
  key,
  setShowButtons,
  onChange,
  current,
  type,
  state,
  dispatch,
}) => {
  const v = list[index];
  return v ? (
    <CellMeasurer cache={cache} index={index} key={v.url} parent={parent}>
      {!(type === 1) ? (
        <Popover
          placement="rightTop"
          visible={!v.checked && !v.delete && v.visible}
          content={
            <img
              alt="缩放图片"
              src={v.url}
              className="waterFall_autoResponsiveItemPopover"
            />
          }
          destroyTooltipOnHide
        >
          <div
            className="autoResponsiveItem"
            style={{ ...style, ...v.style }}
            onClick={() => !v.delete && onChange(index, "choose")}
          >
            {(v.checked || v.delete) && !v.star ? (
              <div
                className="autoResponsiveImgMask"
                style={{
                  width: v.style.width,
                  height: v.style.height,
                  color: v.delete ? "#ff4d4f" : "#fff",
                }}
              >
                {v.delete ? "已删除" : "已选择"}
              </div>
            ) : null}
            {current >= 2 && v.star ? (
              <div
                className="autoResponsiveImgMask"
                style={{
                  width: v.style.width,
                  height: v.style.height,
                  color: v.delete ? "#ff4d4f" : "#fff",
                }}
              >
                {v.star === 1
                  ? "⭐"
                  : v.star === 2
                  ? "⭐⭐"
                  : v.star === 3
                  ? "⭐⭐⭐"
                  : ""}
              </div>
            ) : null}
            <SimpleImg
              width={v.style.width}
              height={v.style.height}
              className="autoResponsiveCover"
              importance={"low"}
              animationDuration={0.1}
              src={v.url}
            />
            {!(v.checked || v.delete) ? (
              <>
                <div
                  className="autoResponsiveItemShowImg"
                  onMouseOver={() => {
                    setShowButtons(index);
                    !v.delete && !v.checked && onChange(index, "pop");
                  }}
                  onMouseLeave={() => {
                    setShowButtons(-1);
                    !v.delete && !v.checked && onChange(index, "hide");
                  }}
                  onClick={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    !v.checked && !v.delete && onChange(index, "showBigImg");
                  }}
                >
                  <Tooltip title="点击查看大图">
                    <img
                      alt="放大或者查看"
                      src="https://cdn.code.znzmo.com/manager/lookUp.png"
                      width="30px"
                      height="30px"
                    />
                  </Tooltip>
                </div>
                <Modal
                  visible={v.showBigImg}
                  destroyOnClose
                  onCancel={(e) => {
                    e.stopPropagation();
                    e.preventDefault();
                    !v.checked && !v.delete && onChange(index, "hideBigImg");
                  }}
                  footer={null}
                  title={null}
                  wrapClassName="waterFall_autoResponsiveItemPopover_showBig"
                  width="100%"
                >
                  <img alt="" src={v.url} />
                </Modal>
              </>
            ) : // </Popover>
            null}
            {current === 1 && !v.delete ? (
              <Tooltip
                title={
                  <ul style={{ listStyle: "none", margin: 0, padding: 0 }}>
                    {renderTagsList(v.newTags, 1)}
                  </ul>
                }
              >
                <div className="insTaggedList">
                  {renderTagsList(v.newTags, 0)}
                </div>
              </Tooltip>
            ) : null}
            {!v.delete && !v.star && current <= 1 ? (
              <Tooltip title="删除该图片之后，请点击下一步">
                <div
                  className="auditManagerWaterFallItemCross"
                  onClick={(e) => {
                    e.stopPropagation();
                    const tag = current >= 2 ? "star" : "delete";
                    const startCount =
                      current === 2 ? 1 : current === 3 ? 3 : 1;
                    onChange(index, tag, startCount);
                  }}
                >
                  <span>×</span>
                </div>
              </Tooltip>
            ) : null}
          </div>
        </Popover>
      ) : (
        <Popover
          content={
            <div>
              <div>星级：{v.star}星</div>
              <div>
                <div>标签</div>
                <ul>
                  {v?.tags?.map((v, i) => (
                    <li key={i}>{v.word}</li>
                  ))}
                </ul>
              </div>
            </div>
          }
        >
          <div
            className="autoResponsiveItem"
            style={{ ...style, ...v.style }}
            onDoubleClick={() => {
              dispatch({
                type: actiontypes.setData,
                data: {
                  bigImgModalVisible: true,
                  bigImgModalSource: v.url,
                },
              });
            }}
            onClick={() => state.watchUpModel === 1 && onChange(index, "choose")}
          >
            {v.checked && state.watchUpModel === 1 ? (
              <div
                className="autoResponsiveImgMask"
                style={{
                  width: v.style.width,
                  height: v.style.height,
                }}
              >
                {v.checked ? "已选择" : ""}
              </div>
            ) : null}
            <SimpleImg
              width={v.style.width}
              height={v.style.height}
              className="autoResponsiveCover"
              importance={"low"}
              animationDuration={0.1}
              src={v.url}
            />
          </div>
        </Popover>
      )}
    </CellMeasurer>
  ) : null;
};

export default (props) => {
  const [showList, setShowList] = useState([]);
  const [showButtons, setShowButtons] = useState(-1);
  const { state, dispatch } = useContext(AuditMarkingContext);
  const {
    list,
    itemWidth,
    containerWidth,
    noButtons,
    downloadTag,
    tips,
    isDesc,
    noFeedBack,
    columnCount,
    diffHeight = 0,
    needResize,
    onChange,
    type,
  } = props;

  const masonryRef = useRef(null);
  const cacheRef = useRef(cache);
  const cellPositionerRef = useRef(cellPositioner);
  const columnCountRef = useRef(columnCount);
  const [spacer, setSpacer] = useState(10);
  const widthRef = useRef(containerWidth);
  const heightRef = useRef(100);
  const scrollTopRef = useRef(0);
  const scrollEle = useRef(null);

  useEffect(() => {
    setSpacer((containerWidth - itemWidth * columnCount) / (columnCount - 1));
  }, [itemWidth, containerWidth]);

  useEffect(() => {
    if (type === 1) {
      const newList = state.watchUpModalSource.map((v, i) => {
        let height = (v.height / v.width) * itemWidth;
        let style = {
          width: itemWidth,
          height: height,
        };
        return {
          ...v,
          height,
          style,
        };
      });
      setShowList(newList);
      if (state.virtualWaterUpdate) {
        cellPositionerRef.current.reset({
          columnCount: columnCount,
          columnWidth: itemWidth,
          spacer: spacer,
        });
        cacheRef.current.clearAll();
        masonryRef.current.clearCellPositions();
        dispatch({
          type: actiontypes.setData,
          data: {
            virtualWaterUpdate: false,
          },
        });
      }
      return;
    }
    const newList = state.insGroup.map((v, i) => {
      let height = (v.height / v.width) * itemWidth;
      let style = {
        width: itemWidth,
        height: height,
      };
      return {
        ...v,
        height,
        style,
      };
    });
    setShowList(newList);
    if (state.virtualWaterUpdate) {
      cellPositionerRef.current.reset({
        columnCount: columnCount,
        columnWidth: itemWidth,
        spacer: spacer,
      });
      cacheRef.current.clearAll();
      masonryRef.current.clearCellPositions();
      dispatch({
        type: actiontypes.setData,
        data: {
          virtualWaterUpdate: false,
        },
      });
    }
  }, [
    state.insGroup,
    state.virtualWaterUpdate,
    type,
    state.watchUpModalSource,
  ]);

  useEffect(() => {
    cellPositionerRef.current.reset({
      columnCount: columnCount,
      columnWidth: itemWidth,
      spacer: spacer,
    });
    cacheRef.current.clearAll();
    masonryRef.current.clearCellPositions();
  }, [spacer]);

  const _calculateColumnCount = () => {
    const calcColumn = widthRef.current / (itemWidth + spacer);
    columnCountRef.current =
      calcColumn + 0.2 > columnCount ? columnCount : Math.floor(calcColumn);
  };

  const _resetCellPositioner = () => {
    cellPositionerRef.current.reset({
      columnCount: columnCountRef.current,
      columnWidth: itemWidth,
      spacer: spacer,
    });
  };

  const onResize = ({ width }) => {
    widthRef.current = width;
    _calculateColumnCount();
    _resetCellPositioner();
    masonryRef.current.recomputeCellPositions();
  };

  return (
    <div ref={scrollEle} style={{ height: 600, overflowY: "scroll" }}>
      <WindowScroller
        scrollingResetTimeInterval={0}
        scrollElement={scrollEle.current || window}
      >
        {({ height, scrollTop }) => {
          heightRef.current = height;
          scrollTopRef.current = scrollTop;
          return (
            <AutoSizer
              disableHeight
              overscanByPixels={50}
              height={heightRef.current}
              scrollTop={scrollTopRef.current}
              onResize={onResize}
            >
              {({ width }) => {
                widthRef.current = width;
                return (
                  <Masonry
                    ref={masonryRef}
                    autoHeight
                    width={width}
                    height={heightRef.current + 600}
                    scrollTop={scrollTopRef.current - diffHeight}
                    overscanByPixels={20}
                    cellCount={showList.length}
                    cellMeasurerCache={cacheRef.current}
                    cellPositioner={cellPositionerRef.current}
                    cellRenderer={(params) => {
                      return cellRenderer({
                        ...params,
                        list: showList,
                        noButtons,
                        showButtons,
                        downloadTag,
                        tips,
                        noFeedBack,
                        itemWidth,
                        isDesc,
                        setShowButtons,
                        onChange,
                        current: state.current,
                        type,
                        state,
                        dispatch,
                      });
                    }}
                  />
                );
              }}
            </AutoSizer>
          );
        }}
      </WindowScroller>
    </div>
  );
};
